<template>
    <section class="section_6 why-use-us">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <div class="heading">
                <h3 style="color: #28a745; font-weight: 800; cursor:pointer;">{{ cmsData.why_use_us_title }}</h3>
                <p>
                    {{ cmsData.why_use_us_sub_title }}
                </p>
            </div>
            <div class="row m-0">
                <div class="col-12 col-md-4 custom_card border_bottom" v-for="(row, index) in cmsWhyuseus" :key="index">
                    <div class="border-box ">
                        <a href="javascript:void(0);" title="ResellerRatings" target="_blank">
                            <div class="img">
                                <img :src="imagePath + row.image">
                            </div>
                            <h5> {{ row.title }} </h5>
                            <p class="hide-for-small-only"> {{ row.sub_title }} </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "WhyUs",
    props:['cmsData','cmsWhyuseus'],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            data: [],
            imagePath: this.$api + "upload/why_use_us/"
        }
    }
}
</script>